<template>
  <v-app>
    <v-app-bar class="white elevation-1"
      :class="!this.$vuetify.breakpoint.sm && !this.$vuetify.breakpoint.xs ? null : 'mobile--appbar elevation-0'"
    fixed dense dark app>
      <!-- <v-app-bar-nav-icon light></v-app-bar-nav-icon> -->
      <v-toolbar-title class="black--text"
        ><b v-if="!bookingLoading">บริษัท {{ bookingList.vendorName }}</b> <span v-if="bookingList.rating"><v-icon class="mb-1" color="#FFD233">mdi-star</v-icon>{{ bookingList.rating }} / 5</span></v-toolbar-title
      >
      <v-spacer></v-spacer>
    </v-app-bar>
    <v-main 
    :class="!this.$vuetify.breakpoint.sm && !this.$vuetify.breakpoint.xs ? 'main-bg' : 'mobile--main-bg'"
    >
      <!-- <List @rowSelected="rowSelected" :items="bookingList" :header="vTableHeaders" :loadings="bookingLoading" /> -->
      <template v-if="!this.$vuetify.breakpoint.sm && !this.$vuetify.breakpoint.xs">
        <v-row>
          <v-col cols="12">
            <div class="pa-4" style="background-color: white">
              <v-data-table
                class="row-pointer"
                :loading="bookingLoading"
                :headers="vTableHeaders"
                :items="bookingList.bookings"
                :page.sync="page"
                :items-per-page="pageLimit"
                multi-sort
                hide-default-footer
                @page-count="pages = $event"
                @click:row="rowSelected"
              >
                <template v-slot:[`item.statusName`]='{ item }'>
                  <v-chip :style="{ backgroundColor: item.statusBgColorCode }">
                    <b :style="'color:' + item.statusColorCode">{{ item.statusName }}</b>
                  </v-chip>
                </template>
                <template v-slot:no-data>
                  <b>ไม่พบข้อมูล</b>
                </template>
              </v-data-table>
              <div class="text-center pt-2">
                <v-pagination v-model="page" :length="pages"></v-pagination>
              </div>
            </div>
          </v-col>
        </v-row>
      </template>
      <template v-else>
        <v-card class="ma-4 pa-4" elevation="0" v-for="(value, index) in bookingList.bookings" :key="index"  @click="rowSelected(value)">
          <v-row no-gutters >
            <v-col cols="6">
              <span class="mobile--card-title">{{ value.bookingNo }}</span>
            </v-col>
            <v-col cols="6" class="text-right">
              <v-chip :style="{ backgroundColor: value.statusBgColorCode }">
                <b :style="'color:' + value.statusColorCode">{{ value.statusName }}</b>
              </v-chip>
            </v-col>
            <v-col cols="6">
              <v-row no-gutters class="mobile--card-detail">
                <v-col cols="12">
                  <span class="label">วันที่นัด</span>
                </v-col>
                <v-col cols="12">
                  <span class="text">{{ value.appointedAtDate }}</span>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="6">
              <v-row v-if="value.rating" no-gutters class="mobile--card-detail">
                <v-col cols="12">
                  <span class="label">คะแนนรีวิว</span>
                </v-col>
                <v-col cols="12">
                  <span class="text">
                    <v-icon style="font-size: 16px;" class="mr-1" color="#FFD233">mdi-star</v-icon>{{ value.rating }} / 5
                  </span>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="6">
              <v-row no-gutters class="mobile--card-detail">
                <v-col cols="12">
                  <span class="label">ผู้ส่งคำร้อง</span>
                </v-col>
                <v-col cols="12">
                  <span class="text">{{ value.contactName }}</span>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="6">
              <v-row no-gutters class="mobile--card-detail">
                <v-col cols="12">
                  <span class="label">เบอร์โทรติดต่อ</span>
                </v-col>
                <v-col cols="12">
                  <span class="text">{{ value.tel || '-' }}</span>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
        
      </template>
      <!-- <Footer></Footer> -->
    </v-main>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex';
import {
  BOOKING_LIST_REQUEST,
} from '@/store/actions/booking';
import { DETAIL } from '@/router/constant';
// import Footer from "@/components/Footer.vue";
// import List from "@/components/List.vue";
// import DetailModal from "@/components/DetailModal.vue";

export default {
  components: {
    // Footer,
    // List,
    // DetailModal,
  },
  computed: {
    ...mapGetters(['bookingList', 'bookingLoading']),
  },
  data: () => ({
    isPageLoading: false,
    pageLimit: 10,
    pages: 0,
    page: 1,
    vTableHeaders: [
      {
        text: "เลขที่ใบงาน",
        value: "bookingNo",
      },
      { text: "ประเภทงาน", value: "serviceName" },
      { text: "ผู้ส่งคำร้อง", value: "contactName" },
      { text: "วันที่ร้องขอ", value: "createdAtDate" },
      { text: "วันที่นัด", value: "appointedAtDate" },
      { text: "สถานะ", value: "statusName" },
      { text: "เรตติ้ง", value: "rating" }
    ],
    list: [
      {
        vendorNameTh: "บจก. สยามไดกิ้นเซลส์",
        hasAc: true,
        hasHomeDecoration: true,
        hasCleaning: true,
        hasGardening: true,
        rating: 4.8,
      },
      {
        vendorNameTh: "ไอเออร์ อีเล็คทริค จำกัด",
        hasAc: true,
        hasHomeDecoration: false,
        hasCleaning: true,
        hasGardening: false,
        rating: 5.0,
      },
    ],
    selectedStatus: "ALL",
    selectedData: null,
    isShowDetailModal: false,
  }),
  async created() {
    await this.fetch();
  },
  methods: {
    async fetch() {
      // const token = this.$store.getters.accessToken;
      const token = this.$route.query.token;
      console.log('fetch token', token);
      await this.$store.dispatch(BOOKING_LIST_REQUEST, { token: token });
    },
    rowSelected(a) {
      console.log('rowSelected a', a);
      this.selectedData = a;
      // this.$router.push({ name: DETAIL, params: { id: a.objectId } });
      const storeData = JSON.parse(localStorage.getItem('vendor_app'));
      this.$router.push({ name: DETAIL, params: { 
        env: storeData.system,
        id: a.objectId 
      }, query: { token: this.$route.query.token }  });
      // this.onClickShowDetail();
    },
    saved() {
      console.log('saved', this.selectedData);
    },
    onClickShowDetail() {
      this.isShowDetailModal = true;
    },
    closeDetailModal() {
      this.selectedData = null;
      this.isShowDetailModal = false;
    },
  },
};
</script>

<style lang="scss" scope>
.mobile--appbar {
  display: flex;
  justify-content: center;
}
.mobile--main-bg {
  background-color: #F3F3F5 !important;
}
.mobile--card-title {
  font-size: 16px;
  font-weight: bold;
  color: #181818;
}
.mobile--card-detail {
  font-size: 14px;

  .label {
    color: #9F9F9F;
  }
  .text {
    color: #181818;
  }
}



#vendor-detail-modal {
  .tabs-title {
    font-size: 14px;
    text-transform: none !important;
    font-weight: normal;
    color: #0000008a !important;
  }
  .v-tab--active .tabs-title {
    color: #1976d2 !important;
  }
  #commercial-service-booking-detail-tabs .v-tabs-bar {
    border-bottom: 1px solid #ebebeb;
  }

  @media only screen and (max-width: 959.98px) {
    .v-stepper:not(.v-stepper--vertical) .v-stepper__label {
      display: flex;
    }
    .v-card__text {
      padding: 0;
    }
    .v-toolbar__title {
      display: flex;
      justify-content: center;
      width: 100%;
    }
  }
}
</style>